import { Button, Modal } from "components";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCopyData } from "store/globalSlice";
import { icons } from "utils/constants";
import { copyToClipboard, titleCaseString } from "utils/helpers";

const Apikeypopup = () => {
  const dispatch = useDispatch();
  const reduxData = useSelector((state) => state.global);
  const { copyData, isDarkMode } = reduxData || {};
  const [copyID, setCopyID] = useState("");

  useEffect(() => {
    if (copyID) {
      setTimeout(() => {
        setCopyID("");
      }, 1000);
    }
  }, [copyID]);

  const { api_key, http_end_point, ws_end_point, rpc_end_point, type } =
    copyData || {};
  const list = [
    {
      label: "API Key",
      key: api_key,
      show: api_key ? true : false,
    },
    {
      label: `HTTPS${type === "unification" ? " REST" : ""}`,
      key: http_end_point,
      show: http_end_point ? true : false,
    },
    {
      label: `${type === "unification" ? "RPC Websocket" : "WebSocket"}`,
      key: ws_end_point,
      show: ws_end_point ? true : false,
    },
    {
      label: "RPC HTTPS",
      key: rpc_end_point,
      show: rpc_end_point ? true : false,
    },
  ];
  return (
    <>
      {copyData && (
        <Modal
          title={`Connect to ${titleCaseString(type || "unification")}`}
          width="650px"
          onHide={() => {
            dispatch(setCopyData(null));
          }}
          isDarkMode={isDarkMode}
        >
          <div className="cpt-26 cps-26 cpe-26">
            {list.map((elm, index) => {
              return (
                <div
                  key={index}
                  className={`${list.length - 1 === index ? "" : "cmb-20"} ${elm.show ? "" : "d-none"
                    }`}
                >
                  <div className={`text-16-500 ${isDarkMode ? "color-ffff" : "color-2749"}`}>{elm.label}</div>
                  <div className="d-flex justify-content-between gap-3">
                    <div className={`text-14-400 ${isDarkMode ? "color-ffff" : "color-2749"} ${isDarkMode ? "bg-4d6c" : "bg-f9fb"} cpt-14 cpb-14 cps-14 flex-grow-1 br-8 un text-elipses`}>
                      {elm.key}
                    </div>
                    <div>
                      <Button
                        btnStyle="PD"
                        leftIcon={icons.copy}
                        className={
                          copyID === index + 1 ? "w-124" : "cps-28 cpe-28 w-124"
                        }
                        btnText={copyID === index + 1 ? "Copied" : "Copy"}
                        onClick={() => {
                          copyToClipboard(elm.key);
                          setCopyID(index + 1);
                        }}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
            {/* <div className="cmb-20">
              <div className="text-16-500 color-2749">API Key</div>
              <div className="d-flex justify-content-between gap-3">
                <div className="text-14-400 color-2749 bg-f9fb cpt-14 cpb-14 cps-14 flex-grow-1 br-8 un text-elipses">
                  {api_key}
                </div>
                <div>
                  <Button
                    btnStyle="PD"
                    leftIcon={icons.copy}
                    className={copyID === "1" ? "w-124" : "cps-28 cpe-28 w-124"}
                    btnText={copyID === "1" ? "Copied" : "Copy"}
                    onClick={async () => {
                      copyToClipboard(api_key);
                      setCopyID("1");
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="cmb-20">
              <div className="text-16-500 color-2749">HTTPS</div>
              <div className="d-flex justify-content-between gap-3">
                <div className="text-14-400 color-2749 bg-f9fb cpt-14 cpb-14 cps-14 flex-grow-1 br-8 un text-elipses">
                  {http_end_point}
                </div>
                <div>
                  <Button
                    btnStyle="PD"
                    leftIcon={icons.copy}
                    className={copyID === "2" ? "w-124" : "cps-28 cpe-28 w-124"}
                    btnText={copyID === "2" ? "Copied" : "Copy"}
                    onClick={() => {
                      copyToClipboard(http_end_point);
                      setCopyID("2");
                    }}
                  />
                </div>
              </div>
            </div>
            <div>
              <div className="text-16-500 color-2749">WebSocket</div>
              <div className="d-flex justify-content-between gap-3">
                <div className="text-14-400 color-2749 bg-f9fb cpt-14 cpb-14 cps-14 flex-grow-1 br-8 un text-elipses">
                  {ws_end_point}
                </div>
                <div>
                  <Button
                    btnStyle="PD"
                    leftIcon={icons.copy}
                    className={copyID === "3" ? "w-124" : "cps-28 cpe-28 w-124"}
                    btnText={copyID === "3" ? "Copied" : "Copy"}
                    onClick={() => {
                      copyToClipboard(ws_end_point);
                      setCopyID("3");
                    }}
                  />
                </div>
              </div>
            </div> */}
          </div>
        </Modal>
      )}
    </>
  );
};

export default Apikeypopup;
